import { getOrders } from '@openapi/orders/orders';

export const ALL_PAGES_PAGE_SIZE = 500;

export const MASS_OPERATION_TYPE = {
    CANCEL_AND_REFUND: 'cancel_and_refund',
    CANCEL_WITHOUT_REFUND: 'cancel_without_refund',
    REFUND_ONLY: 'refund_only',
};

export const REFUND_MODE = {
    FULL: 'full',
    PERCENTAGE: 'percentage',
    FIXED: 'fixed',
};

export const getErrorMessage = (error, fallback) => {
    return error?.response?.data?.message || error?.message || fallback;
};

export const getBookingDisplayName = (booking) => {
    return `${booking.firstName || ''} ${booking.lastName || ''}`.trim() || `#${booking.id}`;
};

export const calculateRefundableAmount = async (bookingId, refundableAmountCache) => {
    if (refundableAmountCache.has(bookingId)) {
        return refundableAmountCache.get(bookingId);
    }

    const pageSize = 100;
    let page = 0;
    let hasMorePages = true;
    const allOrders = [];

    while (hasMorePages) {
        const response = await getOrders({
            optionalId: bookingId,
            page,
            pageSize,
        });

        const responseOrders = response?.orders || [];
        allOrders.push(...responseOrders);

        if (responseOrders.length === 0) {
            hasMorePages = false;
        } else if (typeof response?.total === 'number') {
            hasMorePages = allOrders.length < response.total;
        } else {
            hasMorePages = responseOrders.length === pageSize;
        }

        page += 1;
    }

    // Use order.amount (same as backend CancelBooking.ts) — refund orders have
    // negative amounts, so the sum naturally gives the remaining refundable total.
    const maxRefundableAmount = allOrders.reduce((sum, order) => sum + (order.amount || 0), 0);

    refundableAmountCache.set(bookingId, maxRefundableAmount);
    return maxRefundableAmount;
};

export const calculateAmountForRow = async ({
    bookingId,
    refundMode,
    refundValue,
    refundableAmountCache,
}) => {
    const maxRefundableAmount = await calculateRefundableAmount(bookingId, refundableAmountCache);

    if (refundMode === REFUND_MODE.FULL) {
        return Math.max(0, maxRefundableAmount);
    }

    if (refundMode === REFUND_MODE.PERCENTAGE) {
        const percentage = Math.min(100, Math.max(0, Number(refundValue) || 0));
        return Math.max(0, Math.floor((maxRefundableAmount * percentage) / 100));
    }

    const fixedAmount = Math.max(0, Math.floor((Number(refundValue) || 0) * 100));
    return Math.min(fixedAmount, Math.max(0, maxRefundableAmount));
};
